import React from 'react';
import { ApiStore, Subscribe } from 'Store';

// Components
import { Header, Anchor, Footnote } from 'Components/core';
import Card from 'Components/Card';
import CardContainer from 'Components/Card/CardContainer';

// Icons
import AlarmIcon from 'Icons/alarm.svg';
import MedkitIcon from 'Icons/medkit.svg';
import StethoscopeIcon from 'Icons/stethoscope.svg';
import downloadIcon from 'Icons/download.svg';
import CODES from 'Root/libs/analytics/CodeDef';
import { toHumanReadable } from 'Root/Libs/date';
import { toArray } from 'Root/libs/array';
import styled from 'styled-components';

const WrapP= styled.p`
text-align:left ;
margin-top:10px;

    ul{
      
      margin-top:0px ;
    }

    p{
      margin-bottom:10px ;
    }

`;

export default props => (
  <Subscribe to={[ApiStore]}>
    {state => (
      <>
      <CardContainer style={{justifyContent:'space-between'}}>
        {state?.datesToRemember?.OEDates && <Card>
        
          <Header>
            {state?.datesToRemember?.headLine ||  ""}
          </Header>
        
          <WrapP dangerouslySetInnerHTML={{__html:state?.datesToRemember?.OEDates}}>
         
          </WrapP>

        </Card>}
        {state?.datesToRemember?.WaiverDates &&<Card>
   
          <Header>
            {state?.datesToRemember?.waiverDeadline ||"Waiver Deadline" } 
          </Header>
          <WrapP dangerouslySetInnerHTML={{__html:state?.datesToRemember?.WaiverDates}}>
           
          </WrapP>
          
        </Card>}
        {state?.moreEnrollmentMaterials  && <Card>
  
          <Header>
          Plan Materials         
          </Header>
          <WrapP>
            <ul>
              {toArray(state?.moreEnrollmentMaterials?.resource).map(resource=>
                <li>
                  <Anchor code={CODES.MORE_ENROLL_MAT} to={resource.url}>   {resource.label+""}  </Anchor> 
                </li>
              )}
            </ul>
          </WrapP>
        </Card>}
        
      </CardContainer>
      {state?.datesToRemember?.datesFootNote && <div>{toArray(state?.datesToRemember?.datesFootNote).map(text=><Footnote>{text}</Footnote>)}</div>}
       
      </>
    )}
      
  </Subscribe>
);
